import React from "react"
import { GetTable } from "../../common/components/DataTable"
import { BruciatoreDto } from "../../generated"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import Store from "../bruciatoriStore";
import { attach } from "../../common/componentExtensions";
import { Loading } from "../../common/components/loading";

const Table = GetTable<BruciatoreDto>();
export default attach(() => {
    const data = Store.useAll();
    if (!data)
        return <Loading />
    return <div className="card">
        <div className="card-header bg-theme d-flex align-items-center">
            <div className="flex-fill"><h3 className="text-white mb-0">Modelli Bruciatori</h3></div>
            <Link to={links.bruciatoriNew} className="btn btn-outline-secondary"><i className="fas fa-plus me-2" /> Aggiungi</Link>
        </div>
        <div className="card-body">
            <Table
                data={data}
                keySelector={x => x.idBruciatore.toString()}
                filterables={[x => x.marcaBruciatore, x => x.modelloBruciatore, x => x.tipoBruciatore]}
            >
                <Table.Column
                    header="Marca"
                    template={x => <Link to={links.bruciatoriEdit(x.idBruciatore)}>{x.marcaBruciatore}</Link>}
                    orderBy={x => x.marcaBruciatore ?? ""}
                    groupBy={x => x.marcaBruciatore ?? ""}
                />
                <Table.Column
                    header="Modello"
                    template={x => x.modelloBruciatore}
                />
                <Table.Column
                    header="Campo Funz. Da"
                    template={x => x.campoFunzionamentoDa < 0 ? "N.C." : `${x.campoFunzionamentoDa} KW`}
                />
                <Table.Column
                    header="Campo Funz. A"
                    template={x => x.campoFunzionamentoA < 0 ? "N.C." : `${x.campoFunzionamentoA} KW`}
                />
            </Table>
        </div>
    </div>

}, Store, store => ({ data: store.getall() }));